import { hasValidLicense } from "../../managers/license/LicenseState";
import { LICENSES_KEY } from "../../managers/license/queries";
import type { LicensesResponse } from "../../managers/license/types/license.api";
import { useSessionQuery, type LiveState } from "../session/useSessionQuery";

export function useHasValidLicense(): LiveState<boolean> {
    return useSessionQuery<LicensesResponse, boolean>(
        LICENSES_KEY,
        undefined,
        hasValidLicense,
    );
}
